import { render } from "./ApplicantForm.vue?vue&type=template&id=be8d9e54&scoped=true"
import script from "./ApplicantForm.vue?vue&type=script&lang=js"
export * from "./ApplicantForm.vue?vue&type=script&lang=js"

import "./ApplicantForm.vue?vue&type=style&index=0&id=be8d9e54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8d9e54"]])

export default __exports__